import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  GenericIconName,
  Icon,
  SliderControlProps,
  Text,
  UnstyledButton,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const ProductOutfitPagination: React.FC<SliderControlProps> = ({
  currentSlide,
  maxPages,
  nextIsActive,
  prevIsActive,
  scrollToNextItem,
  scrollToPrevItem,
}) => {
  const {t} = useTranslation();

  return (
    <Wrapper>
      <PrevButton
        onClick={scrollToPrevItem}
        disabled={!prevIsActive}
        data-testid="productOutfitPaginationPrevButton"
        aria-label={t('Go to the previous slide')}
      >
        <Icon
          size="XS"
          asset={GenericIconName.ArrowLeft}
          fill={prevIsActive ? COLORS.Black : COLORS.Grey2}
        />
      </PrevButton>
      <Page size="px10" color="Grey0" textAlignment="center">
        {currentSlide + 1} / {maxPages}
      </Page>
      <NextButton
        onClick={scrollToNextItem}
        disabled={!nextIsActive}
        data-testid="productOutfitPaginationForwardButton"
        aria-label={t('Go to the next slide')}
      >
        <Icon
          size="XS"
          asset={GenericIconName.ArrowRight}
          fill={nextIsActive ? COLORS.Black : COLORS.Grey2}
        />
      </NextButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${COLORS.Grey4};
  border-radius: 24px;
  width: 147px;
  height: 36px;
  margin: 24px auto 0 auto;
  overflow: hidden;
`;

const PrevButton = styled(UnstyledButton)`
  padding: 10px;
  border: none;
  border-right: 1px solid ${COLORS.Grey4};
  background: none;
`;

const NextButton = styled(UnstyledButton)`
  padding: 10px;
  border: none;
  border-left: 1px solid ${COLORS.Grey4};
  background: none;
`;

const Page = styled(Text)`
  flex: 1;
  letter-spacing: 3px;
`;
